// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Custom Login Page Styles
 * Following Promotly Design System from architecture document
 */

/* Import Poppins font - removed remote @import url() because CRA production css-minimizer fails on it. Font loads via index.html link instead. */

/* CSS Variables - Promotly Design System */
:root {
  /* Primary Brand Colors */
  --primary-dark-blue: #1e3a8a;
  --primary-light-blue: #1e40af;
  --secondary-blue: #4b6dde;
  --tertiary-blue: #0d6efd;

  /* Background Colors */
  --bg-primary: #ffffff;
  --bg-secondary: #f0f9ff;
  --bg-tertiary: #fafbfc;
  --bg-border: #f3f4f6;

  /* Text Colors */
  --text-primary: #030303;
  --text-secondary: #5e5e5e;
  --text-muted: #94a3b8;
  --text-error: #dc2626;
  --text-success: #10b981;
  --text-warning: #92400e;

  /* Border & Shadow Colors */
  --border-light: #e5e7eb;
  --border-error: #fca5a5;
  --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.1);
  --shadow-md: 0 4px 8px rgba(30, 58, 138, 0.2);
  --shadow-lg: 0 10px 25px rgba(0, 0, 0, 0.15);

  /* Spacing Scale */
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 12px;
  --spacing-lg: 16px;
  --spacing-xl: 20px;
  --spacing-2xl: 24px;
  --spacing-3xl: 32px;
  --spacing-4xl: 40px;
  --spacing-5xl: 48px;
}

/* Reset and Base Styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Login Page Container */
.custom-login-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-primary);
}

/* Header */
.custom-login-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-lg) var(--spacing-2xl);
  border-bottom: 1px solid var(--bg-border);
  background: var(--bg-primary);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.custom-login-logo {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  text-decoration: none;
}

.custom-login-logo-img {
  height: 68px;
  width: auto;
  object-fit: contain;
}

/* Prevent logo image from flipping in RTL mode */
[dir="rtl"] .custom-login-logo-img {
  transform: none;
}

.custom-login-logo-text {
  font-size: 20px;
  font-weight: 600;
  color: var(--primary-dark-blue);
}

/* Segmented Language Switcher */
.custom-login-language-segmented {
  display: flex;
  align-items: center;
  background: #f1f5f9;
  border-radius: 24px;
  padding: 4px;
  gap: 2px;
  border: 1px solid #e2e8f0;
}

.lang-segment {
  padding: 8px 16px;
  border: none;
  background: transparent;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.25s ease;
  min-width: 70px;
}

.lang-segment:hover:not(.active) {
  color: #475569;
  background: rgba(255, 255, 255, 0.5);
}

.lang-segment.active {
  background: #ffffff;
  color: var(--primary-dark-blue);
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* RTL Support for Language Switcher */
[dir="rtl"] .custom-login-language-segmented {
  flex-direction: row;
}

/* Main Container */
.custom-login-container {
  flex: 1 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: calc(100vh - 76px);
}

/* Left Column - Form Section */
.custom-login-form-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-4xl) var(--spacing-2xl);
  background: var(--bg-primary);
}

.custom-login-form-wrapper {
  width: 100%;
  max-width: 480px;
}

.custom-login-title {
  font-size: 28px;
  font-weight: 600;
  color: var(--primary-dark-blue);
  margin-bottom: var(--spacing-md);
  line-height: 1.3;
}

.custom-login-subtitle {
  font-size: 16px;
  font-weight: 400;
  color: var(--text-secondary);
  margin-bottom: var(--spacing-3xl);
}

/* Error Alert */
.custom-login-error-alert {
  background: #fee2e2;
  border: 1px solid var(--border-error);
  border-left: 4px solid var(--text-error);
  color: var(--text-error);
  padding: var(--spacing-md) var(--spacing-lg);
  border-radius: 8px;
  margin-bottom: var(--spacing-xl);
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
}

.custom-login-error-icon {
  font-size: 18px;
}

.custom-login-error-dismiss {
  margin-left: auto;
  background: none;
  border: none;
  color: var(--text-error);
  cursor: pointer;
  font-size: 18px;
  padding: 0;
  line-height: 1;
}

/* Account-context mismatch notice (forced re-login — informational, not an error).
   RTL-safe: logical \`border-inline-start\` / \`margin-inline-start\` so it mirrors in Arabic. */
.custom-login-mismatch-alert {
  background: #fef3c7;
  border: 1px solid #fcd34d;
  border-inline-start: 4px solid #f59e0b;
  color: #92400e;
  padding: var(--spacing-md) var(--spacing-lg);
  border-radius: 8px;
  margin-bottom: var(--spacing-xl);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  text-align: start;
}

.custom-login-mismatch-icon {
  flex-shrink: 0;
  font-size: 18px;
}

.custom-login-mismatch-dismiss {
  margin-inline-start: auto;
  background: none;
  border: none;
  color: #92400e;
  cursor: pointer;
  font-size: 18px;
  padding: 0;
  line-height: 1;
}

/* Form */
.custom-login-form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
}

.custom-login-form-group {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.custom-login-label {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
}

.custom-login-input {
  width: 100%;
  height: 56px;
  padding: 0 var(--spacing-lg);
  border: 1px solid var(--border-light);
  border-radius: 12px;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
  color: var(--text-primary);
  transition: all 0.3s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.custom-login-input::placeholder {
  color: var(--text-muted);
}

.custom-login-input:hover {
  border-color: #c5c9d0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
}

.custom-login-input:focus {
  outline: none;
  border-color: var(--primary-light-blue);
  box-shadow: 0 0 0 4px rgba(30, 64, 175, 0.1);
}

.custom-login-input.error {
  border-color: var(--text-error);
  box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.1);
}

.custom-login-input:disabled {
  background: var(--bg-border);
  color: var(--text-muted);
  cursor: not-allowed;
}

/* Password Input Wrapper */
.custom-login-password-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
}

.custom-login-password-wrapper .custom-login-input {
  padding-right: 48px;
}

.custom-login-password-toggle {
  position: absolute;
  right: var(--spacing-lg);
  top: 50%;
  transform: translateY(-50%);
  background: rgba(245, 245, 245, 0.8);
  border: none;
  border-radius: 6px;
  color: var(--text-muted);
  cursor: pointer;
  padding: var(--spacing-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;
  width: 32px;
  height: 32px;
}

.custom-login-password-toggle:hover {
  color: var(--primary-light-blue);
  background: rgba(30, 64, 175, 0.1);
}

.custom-login-password-toggle:focus {
  outline: none;
  color: var(--primary-light-blue);
}

/* RTL Support for Arabic */
[dir="rtl"] .custom-login-password-wrapper .custom-login-input {
  padding-right: var(--spacing-lg);
  padding-left: 48px;
}

[dir="rtl"] .custom-login-password-toggle {
  right: auto;
  left: var(--spacing-lg);
}

/* Field Error */
.custom-login-field-error {
  font-size: 13px;
  color: var(--text-error);
  margin-top: var(--spacing-xs);
}

/* Links */
.custom-login-links {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: var(--spacing-sm);
}

.custom-login-link {
  font-size: 14px;
  font-weight: 600;
  color: var(--primary-light-blue);
  text-decoration: none;
  transition: all 0.3s ease;
  padding: 4px 8px;
  border-radius: 6px;
  margin: -4px -8px;
}

.custom-login-link:hover {
  text-decoration: underline;
  background: rgba(30, 64, 175, 0.08);
}

/* Remember Me Checkbox */
.custom-login-remember {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.custom-login-checkbox {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: var(--primary-dark-blue);
}

.custom-login-checkbox-label {
  font-size: 14px;
  font-weight: 400;
  color: var(--text-primary);
  cursor: pointer;
}

/* Login Button */
.custom-login-button {
  height: 56px;
  padding: 0 var(--spacing-2xl);
  background: linear-gradient(135deg, var(--primary-dark-blue) 0%, var(--primary-light-blue) 100%);
  color: var(--bg-primary);
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: var(--spacing-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-md);
  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.25);
  letter-spacing: 0.3px;
}

.custom-login-button:hover:not(:disabled) {
  background: linear-gradient(135deg, var(--primary-light-blue) 0%, var(--secondary-blue) 100%);
  box-shadow: 0 8px 20px rgba(30, 58, 138, 0.4);
  transform: translateY(-3px);
}

.custom-login-button:active:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.3);
}

.custom-login-button:disabled {
  background: var(--text-muted);
  cursor: not-allowed;
  transform: none;
}

/* Loading Spinner */
.custom-login-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: var(--bg-primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Social Login Section */
.custom-login-social-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 24px 0 20px;
}

.custom-login-divider-line {
  flex: 1 1;
  height: 1px;
  background: var(--border-light);
}

.custom-login-divider-text {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-muted);
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.custom-login-social-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 8px;
}

/* Footer Links */
.custom-login-footer {
  text-align: center;
  margin-top: var(--spacing-2xl);
  font-size: 14px;
  color: var(--text-secondary);
}

/* Right Column - Welcome Section */
.custom-login-welcome-section {
  background: var(--bg-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-4xl);
}

.custom-login-welcome-image {
  width: 100%;
  height: 88vh;
  object-fit: contain;
}

/* Responsive Design */

/* Tablet (576px - 767px) */
@media (max-width: 767px) {
  .custom-login-container {
    grid-template-columns: 1fr;
  }

  .custom-login-welcome-section {
    order: -1;
    padding: var(--spacing-2xl);
  }

  .custom-login-welcome-image {
    height: 50vh;
  }

  .custom-login-form-section {
    padding: var(--spacing-2xl);
  }
}

/* Mobile (< 576px) */
@media (max-width: 575px) {
  .custom-login-header {
    padding: var(--spacing-md) var(--spacing-lg);
  }

  .custom-login-logo-text {
    font-size: 18px;
  }

  .custom-login-welcome-section {
    display: none;
  }

  .custom-login-form-section {
    padding: var(--spacing-2xl) var(--spacing-lg);
  }

  .custom-login-title {
    font-size: 24px;
  }

  .custom-login-input,
  .custom-login-button {
    height: 48px;
  }

  .custom-login-links {
    flex-direction: column;
    gap: var(--spacing-md);
    align-items: flex-start;
  }
}

/* Accessibility */
.custom-login-input:focus-visible,
.custom-login-button:focus-visible,
.custom-login-link:focus-visible {
  outline: 2px solid var(--primary-light-blue);
  outline-offset: 2px;
}

/* Print Styles */
@media print {
  .custom-login-welcome-section {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/auth/CustomLoginPage.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,iJAAiJ;;AAEjJ,2CAA2C;AAC3C;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;EACzB,wBAAwB;;EAExB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;;EAEpB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;;EAEvB,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,yCAAyC;EACzC,6CAA6C;EAC7C,4CAA4C;;EAE5C,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;kFACgF;EAChF,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6CAA6C;EAC7C,yCAAyC;EACzC,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA,sCAAsC;AACtC;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,SAAO;EACP,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,qCAAqC;EACrC,wCAAwC;EACxC,wBAAwB;EACxB,4CAA4C;EAC5C,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;6FAC6F;AAC7F;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sCAAsC;EACtC,cAAc;EACd,4CAA4C;EAC5C,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;EAC1B,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,6BAA6B;EAC7B,gGAAgG;EAChG,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,6FAA6F;EAC7F,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,mCAAmC;EACnC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,4BAA4B;AAC9B;;AAEA,mCAAmC;AACnC;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;;AAEtB,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,4CAA4C;EAC9C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,kBAAkB;AAClB;;;EAGE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/**\n * Custom Login Page Styles\n * Following Promotly Design System from architecture document\n */\n\n/* Import Poppins font - removed remote @import url() because CRA production css-minimizer fails on it. Font loads via index.html link instead. */\n\n/* CSS Variables - Promotly Design System */\n:root {\n  /* Primary Brand Colors */\n  --primary-dark-blue: #1e3a8a;\n  --primary-light-blue: #1e40af;\n  --secondary-blue: #4b6dde;\n  --tertiary-blue: #0d6efd;\n\n  /* Background Colors */\n  --bg-primary: #ffffff;\n  --bg-secondary: #f0f9ff;\n  --bg-tertiary: #fafbfc;\n  --bg-border: #f3f4f6;\n\n  /* Text Colors */\n  --text-primary: #030303;\n  --text-secondary: #5e5e5e;\n  --text-muted: #94a3b8;\n  --text-error: #dc2626;\n  --text-success: #10b981;\n  --text-warning: #92400e;\n\n  /* Border & Shadow Colors */\n  --border-light: #e5e7eb;\n  --border-error: #fca5a5;\n  --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.1);\n  --shadow-md: 0 4px 8px rgba(30, 58, 138, 0.2);\n  --shadow-lg: 0 10px 25px rgba(0, 0, 0, 0.15);\n\n  /* Spacing Scale */\n  --spacing-xs: 4px;\n  --spacing-sm: 8px;\n  --spacing-md: 12px;\n  --spacing-lg: 16px;\n  --spacing-xl: 20px;\n  --spacing-2xl: 24px;\n  --spacing-3xl: 32px;\n  --spacing-4xl: 40px;\n  --spacing-5xl: 48px;\n}\n\n/* Reset and Base Styles */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Login Page Container */\n.custom-login-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-primary);\n}\n\n/* Header */\n.custom-login-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--spacing-lg) var(--spacing-2xl);\n  border-bottom: 1px solid var(--bg-border);\n  background: var(--bg-primary);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n.custom-login-logo {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  text-decoration: none;\n}\n\n.custom-login-logo-img {\n  height: 68px;\n  width: auto;\n  object-fit: contain;\n}\n\n/* Prevent logo image from flipping in RTL mode */\n[dir=\"rtl\"] .custom-login-logo-img {\n  transform: none;\n}\n\n.custom-login-logo-text {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--primary-dark-blue);\n}\n\n/* Segmented Language Switcher */\n.custom-login-language-segmented {\n  display: flex;\n  align-items: center;\n  background: #f1f5f9;\n  border-radius: 24px;\n  padding: 4px;\n  gap: 2px;\n  border: 1px solid #e2e8f0;\n}\n\n.lang-segment {\n  padding: 8px 16px;\n  border: none;\n  background: transparent;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  min-width: 70px;\n}\n\n.lang-segment:hover:not(.active) {\n  color: #475569;\n  background: rgba(255, 255, 255, 0.5);\n}\n\n.lang-segment.active {\n  background: #ffffff;\n  color: var(--primary-dark-blue);\n  font-weight: 600;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* RTL Support for Language Switcher */\n[dir=\"rtl\"] .custom-login-language-segmented {\n  flex-direction: row;\n}\n\n/* Main Container */\n.custom-login-container {\n  flex: 1;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  min-height: calc(100vh - 76px);\n}\n\n/* Left Column - Form Section */\n.custom-login-form-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: var(--spacing-4xl) var(--spacing-2xl);\n  background: var(--bg-primary);\n}\n\n.custom-login-form-wrapper {\n  width: 100%;\n  max-width: 480px;\n}\n\n.custom-login-title {\n  font-size: 28px;\n  font-weight: 600;\n  color: var(--primary-dark-blue);\n  margin-bottom: var(--spacing-md);\n  line-height: 1.3;\n}\n\n.custom-login-subtitle {\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--text-secondary);\n  margin-bottom: var(--spacing-3xl);\n}\n\n/* Error Alert */\n.custom-login-error-alert {\n  background: #fee2e2;\n  border: 1px solid var(--border-error);\n  border-left: 4px solid var(--text-error);\n  color: var(--text-error);\n  padding: var(--spacing-md) var(--spacing-lg);\n  border-radius: 8px;\n  margin-bottom: var(--spacing-xl);\n  font-size: 14px;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n}\n\n.custom-login-error-icon {\n  font-size: 18px;\n}\n\n.custom-login-error-dismiss {\n  margin-left: auto;\n  background: none;\n  border: none;\n  color: var(--text-error);\n  cursor: pointer;\n  font-size: 18px;\n  padding: 0;\n  line-height: 1;\n}\n\n/* Account-context mismatch notice (forced re-login — informational, not an error).\n   RTL-safe: logical `border-inline-start` / `margin-inline-start` so it mirrors in Arabic. */\n.custom-login-mismatch-alert {\n  background: #fef3c7;\n  border: 1px solid #fcd34d;\n  border-inline-start: 4px solid #f59e0b;\n  color: #92400e;\n  padding: var(--spacing-md) var(--spacing-lg);\n  border-radius: 8px;\n  margin-bottom: var(--spacing-xl);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  text-align: start;\n}\n\n.custom-login-mismatch-icon {\n  flex-shrink: 0;\n  font-size: 18px;\n}\n\n.custom-login-mismatch-dismiss {\n  margin-inline-start: auto;\n  background: none;\n  border: none;\n  color: #92400e;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 0;\n  line-height: 1;\n}\n\n/* Form */\n.custom-login-form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xl);\n}\n\n.custom-login-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n}\n\n.custom-login-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.custom-login-input {\n  width: 100%;\n  height: 56px;\n  padding: 0 var(--spacing-lg);\n  border: 1px solid var(--border-light);\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 400;\n  font-family: 'Poppins', sans-serif;\n  color: var(--text-primary);\n  transition: all 0.3s ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.custom-login-input::placeholder {\n  color: var(--text-muted);\n}\n\n.custom-login-input:hover {\n  border-color: #c5c9d0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);\n}\n\n.custom-login-input:focus {\n  outline: none;\n  border-color: var(--primary-light-blue);\n  box-shadow: 0 0 0 4px rgba(30, 64, 175, 0.1);\n}\n\n.custom-login-input.error {\n  border-color: var(--text-error);\n  box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.1);\n}\n\n.custom-login-input:disabled {\n  background: var(--bg-border);\n  color: var(--text-muted);\n  cursor: not-allowed;\n}\n\n/* Password Input Wrapper */\n.custom-login-password-wrapper {\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.custom-login-password-wrapper .custom-login-input {\n  padding-right: 48px;\n}\n\n.custom-login-password-toggle {\n  position: absolute;\n  right: var(--spacing-lg);\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(245, 245, 245, 0.8);\n  border: none;\n  border-radius: 6px;\n  color: var(--text-muted);\n  cursor: pointer;\n  padding: var(--spacing-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 10;\n  width: 32px;\n  height: 32px;\n}\n\n.custom-login-password-toggle:hover {\n  color: var(--primary-light-blue);\n  background: rgba(30, 64, 175, 0.1);\n}\n\n.custom-login-password-toggle:focus {\n  outline: none;\n  color: var(--primary-light-blue);\n}\n\n/* RTL Support for Arabic */\n[dir=\"rtl\"] .custom-login-password-wrapper .custom-login-input {\n  padding-right: var(--spacing-lg);\n  padding-left: 48px;\n}\n\n[dir=\"rtl\"] .custom-login-password-toggle {\n  right: auto;\n  left: var(--spacing-lg);\n}\n\n/* Field Error */\n.custom-login-field-error {\n  font-size: 13px;\n  color: var(--text-error);\n  margin-top: var(--spacing-xs);\n}\n\n/* Links */\n.custom-login-links {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: var(--spacing-sm);\n}\n\n.custom-login-link {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--primary-light-blue);\n  text-decoration: none;\n  transition: all 0.3s ease;\n  padding: 4px 8px;\n  border-radius: 6px;\n  margin: -4px -8px;\n}\n\n.custom-login-link:hover {\n  text-decoration: underline;\n  background: rgba(30, 64, 175, 0.08);\n}\n\n/* Remember Me Checkbox */\n.custom-login-remember {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.custom-login-checkbox {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: var(--primary-dark-blue);\n}\n\n.custom-login-checkbox-label {\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--text-primary);\n  cursor: pointer;\n}\n\n/* Login Button */\n.custom-login-button {\n  height: 56px;\n  padding: 0 var(--spacing-2xl);\n  background: linear-gradient(135deg, var(--primary-dark-blue) 0%, var(--primary-light-blue) 100%);\n  color: var(--bg-primary);\n  border: none;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  font-family: 'Poppins', sans-serif;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: var(--spacing-lg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-md);\n  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.25);\n  letter-spacing: 0.3px;\n}\n\n.custom-login-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, var(--primary-light-blue) 0%, var(--secondary-blue) 100%);\n  box-shadow: 0 8px 20px rgba(30, 58, 138, 0.4);\n  transform: translateY(-3px);\n}\n\n.custom-login-button:active:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.3);\n}\n\n.custom-login-button:disabled {\n  background: var(--text-muted);\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Loading Spinner */\n.custom-login-spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: var(--bg-primary);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Social Login Section */\n.custom-login-social-divider {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 24px 0 20px;\n}\n\n.custom-login-divider-line {\n  flex: 1;\n  height: 1px;\n  background: var(--border-light);\n}\n\n.custom-login-divider-text {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-muted);\n  white-space: nowrap;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.custom-login-social-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n/* Footer Links */\n.custom-login-footer {\n  text-align: center;\n  margin-top: var(--spacing-2xl);\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n/* Right Column - Welcome Section */\n.custom-login-welcome-section {\n  background: var(--bg-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-4xl);\n}\n\n.custom-login-welcome-image {\n  width: 100%;\n  height: 88vh;\n  object-fit: contain;\n}\n\n/* Responsive Design */\n\n/* Tablet (576px - 767px) */\n@media (max-width: 767px) {\n  .custom-login-container {\n    grid-template-columns: 1fr;\n  }\n\n  .custom-login-welcome-section {\n    order: -1;\n    padding: var(--spacing-2xl);\n  }\n\n  .custom-login-welcome-image {\n    height: 50vh;\n  }\n\n  .custom-login-form-section {\n    padding: var(--spacing-2xl);\n  }\n}\n\n/* Mobile (< 576px) */\n@media (max-width: 575px) {\n  .custom-login-header {\n    padding: var(--spacing-md) var(--spacing-lg);\n  }\n\n  .custom-login-logo-text {\n    font-size: 18px;\n  }\n\n  .custom-login-welcome-section {\n    display: none;\n  }\n\n  .custom-login-form-section {\n    padding: var(--spacing-2xl) var(--spacing-lg);\n  }\n\n  .custom-login-title {\n    font-size: 24px;\n  }\n\n  .custom-login-input,\n  .custom-login-button {\n    height: 48px;\n  }\n\n  .custom-login-links {\n    flex-direction: column;\n    gap: var(--spacing-md);\n    align-items: flex-start;\n  }\n}\n\n/* Accessibility */\n.custom-login-input:focus-visible,\n.custom-login-button:focus-visible,\n.custom-login-link:focus-visible {\n  outline: 2px solid var(--primary-light-blue);\n  outline-offset: 2px;\n}\n\n/* Print Styles */\n@media print {\n  .custom-login-welcome-section {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
